import { type ReactNode } from 'react';

const BAR = 'animate-pulse rounded-sm bg-white/[0.05]';

const HEADER_WIDTHS = ['w-16', 'w-12', 'w-12', 'w-12'];
const ROW_WIDTHS = ['w-20', 'w-24', 'w-24', 'w-24'];

function HeadRow(): ReactNode {
  return (
    <div className="flex items-center gap-md pb-3">
      {HEADER_WIDTHS.map((w, i) => (
        <div key={i} className={`h-2 ${w} ${BAR}`} />
      ))}
    </div>
  );
}

function BodyRow(): ReactNode {
  return (
    <div className="flex items-center gap-md border-t border-white/[0.06] py-3">
      {ROW_WIDTHS.map((w, i) => (
        <div key={i} className={`h-3 ${w} ${BAR}`} />
      ))}
    </div>
  );
}

export function BonusHistorySkeleton(): ReactNode {
  return (
    <div className="-mx-base px-base">
      <HeadRow />
      {Array.from({ length: 5 }, (_, i) => (
        <BodyRow key={i} />
      ))}
    </div>
  );
}
